import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pickLang, t } from "../lib/i18n";
import { api } from "../lib/api";
import { PlayCircle, ArrowUpRight } from "@phosphor-icons/react";
import { youTubeThumb } from "../lib/youtube";
import SEO from "../components/SEO";

export default function Vlogs() {
  const { lang } = useLang();
  const [vlogs, setVlogs] = useState([]);
  useEffect(() => { api.get("/vlogs").then((r) => setVlogs(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="vlogs-page">
      <SEO
        title={{ en: "Vlogs — MP Sound", gr: "Vlogs — MP Sound" }}
        description={{ en: "Behind-the-scenes videos: festival load-ins, workshop tours, tuning walkthroughs.", gr: "Backstage videos: festival, workshop, tuning." }}
        path="/vlogs"
      />
      <div className="max-w-3xl">
        <div className="label-tag mb-4 slash">{lang === "gr" ? "Βίντεο" : "Watch"}</div>
        <h1 className="display-font text-5xl sm:text-7xl font-black uppercase leading-[0.9] tracking-tighter">
          {lang === "gr" ? <>Φωνή & <span className="neon-text">εικόνα.</span></> : <>Loud & <span className="neon-text">on camera.</span></>}
        </h1>
        <p className="text-gray-300 mt-6 max-w-xl">
          {lang === "gr"
            ? "Backstage, time-lapse, tutorials και επισκέψεις στο workshop μας."
            : "Behind-the-scenes, time-lapses, tutorials and walkthroughs from our crew."}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {vlogs.map((v, i) => (
          <Link key={v.id} to={`/vlogs/${v.slug}`} className="card-dark group overflow-hidden" data-testid={`vlog-card-${i}`}>
            <div className="relative aspect-video bg-[#080809] overflow-hidden">
              <img src={v.thumbnail || youTubeThumb(v.video_url)} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center">
                <PlayCircle size={64} weight="fill" className="text-[#ccff00] drop-shadow-[0_0_24px_rgba(204,255,0,0.6)] opacity-90 group-hover:scale-110 transition-transform" />
              </div>
              {v.duration && (
                <span className="absolute bottom-3 right-3 mono-font text-xs bg-black/80 text-white px-2 py-1">{v.duration}</span>
              )}
            </div>
            <div className="p-5">
              <div className="flex flex-wrap gap-2 mb-3">
                {(v.tags || []).map((tag) => (
                  <span key={tag} className="mono-font text-[10px] uppercase tracking-[0.2em] text-[#ccff00] border border-[#ccff00]/40 px-2 py-1">{tag}</span>
                ))}
              </div>
              <h2 className="display-font text-xl font-bold leading-tight">{pickLang(v.title, lang)}</h2>
              <p className="text-gray-400 mt-3 text-sm line-clamp-2">{pickLang(v.description, lang)}</p>
              <div className="inline-flex items-center gap-1 mt-4 mono-font text-xs uppercase tracking-[0.2em] text-white group-hover:text-[#ccff00]">
                {lang === "gr" ? "Παρακολουθήστε" : "Watch"} <ArrowUpRight size={14} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
